module.exports = {
  CrossStorageClient: require('./client.js'),
  CrossStorageHub: require('./hub.js')
};